(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*  jQuery Nice Select - v1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */
!function(e){e.fn.niceSelect=function(t){function s(t){t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class")||"").addClass(t.attr("disabled")?"disabled":"").attr("tabindex",t.attr("disabled")?null:"0").html('<span class="current"></span><ul class="list"></ul>'));var s=t.next(),n=t.find("option"),i=t.find("option:selected");s.find(".current").html(i.data("display")||i.text()),n.each(function(t){var n=e(this),i=n.data("display");s.find("ul").append(e("<li></li>").attr("data-value",n.val()).attr("data-display",i||null).addClass("option"+(n.is(":selected")?" selected":"")+(n.is(":disabled")?" disabled":"")).html(n.text()))})}if("string"==typeof t)return"update"==t?this.each(function(){var t=e(this),n=e(this).next(".nice-select"),i=n.hasClass("open");n.length&&(n.remove(),s(t),i&&t.next().trigger("click"))}):"destroy"==t?(this.each(function(){var t=e(this),s=e(this).next(".nice-select");s.length&&(s.remove(),t.css("display",""))}),0==e(".nice-select").length&&e(document).off(".nice_select")):console.log('Method "'+t+'" does not exist.'),this;this.hide(),this.each(function(){var t=e(this);t.next().hasClass("nice-select")||s(t)}),e(document).off(".nice_select"),e(document).on("click.nice_select",".nice-select",function(t){var s=e(this);e(".nice-select").not(s).removeClass("open"),s.toggleClass("open"),s.hasClass("open")?(s.find(".option"),s.find(".focus").removeClass("focus"),s.find(".selected").addClass("focus")):s.focus()}),e(document).on("click.nice_select",function(t){0===e(t.target).closest(".nice-select").length&&e(".nice-select").removeClass("open").find(".option")}),e(document).on("click.nice_select",".nice-select .option:not(.disabled)",function(t){var s=e(this),n=s.closest(".nice-select");n.find(".selected").removeClass("selected"),s.addClass("selected");var i=s.data("display")||s.text();n.find(".current").text(i),n.prev("select").val(s.data("value")).trigger("change")}),e(document).on("keydown.nice_select",".nice-select",function(t){var s=e(this),n=e(s.find(".focus")||s.find(".list .option.selected"));if(32==t.keyCode||13==t.keyCode)return s.hasClass("open")?n.trigger("click"):s.trigger("click"),!1;if(40==t.keyCode){if(s.hasClass("open")){var i=n.nextAll(".option:not(.disabled)").first();i.length>0&&(s.find(".focus").removeClass("focus"),i.addClass("focus"))}else s.trigger("click");return!1}if(38==t.keyCode){if(s.hasClass("open")){var l=n.prevAll(".option:not(.disabled)").first();l.length>0&&(s.find(".focus").removeClass("focus"),l.addClass("focus"))}else s.trigger("click");return!1}if(27==t.keyCode)s.hasClass("open")&&s.trigger("click");else if(9==t.keyCode&&s.hasClass("open"))return!1});var n=document.createElement("a").style;return n.cssText="pointer-events:auto","auto"!==n.pointerEvents&&e("html").addClass("no-csspointerevents"),this}}(jQuery);
},{}],2:[function(require,module,exports){
"use strict";

var searchParams = window.location.search;

function handleAuthForm(registerHandler) {
  var userTypeToRegisterElement = $('.popup-signup__type-item');

  if (userTypeToRegisterElement.length) {
    userTypeToRegisterElement.click(function () {
      userTypeToRegisterElement.removeClass('popup-signup__type-item--active');
      $(this).addClass('popup-signup__type-item--active');
    });
  }

  var INVALID_EMAIL_OR_PASSWORD = 2;
  var BLOCKED_ACCOUNT = 3;
  var signupPopup = $('#popup-signup');
  var signupPassword = signupPopup.find('[type="password"]');
  var signupAgreement = signupPopup.find('[type="checkbox"]');
  var signupAgreementBox = signupPopup.find('[for="agreement"]');
  var loginPopup = $('#popup-login');
  var signupForm = $('#popup-signup form');

  function showError(message) {
    loginPopup.find('.popup-login__error').html(message).show();
  }

  function resetError() {
    loginPopup.find('.login-error').hide();
  }

  function toOrigin(path) {
    return window.location.origin + path;
  }

  function isFullPath(url) {
    return /^https?:\/\//i.test(url);
  }

  function loginViaRest(form) {
    resetError();
    var loginData = new FormData(form);
    var isMobile = window.location.host.startsWith('m.');
    var postPath = window.location.origin.replace('.com', '.app');
    if (isMobile) postPath = postPath.replace('.m', '');
    postPath += "/auth/domainLogin/".concat(searchParams);
    fetch(postPath, {
      method: 'POST',
      body: loginData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (response.redirected) {
        window.location.href = response.url;
      } else {
        response.json().then(function (data) {
          var status = response.status;

          if (status >= 200 && status <= 299) {
            window.location.href = data.redirectUrl || toOrigin('/home');
          } else if (status >= 300 && status <= 399) {
            var redirectPath = data.body.redirectPath;
            window.location.href = isFullPath(redirectPath) ? redirectPath : toOrigin(redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath);
          } else if (status >= 400 && status <= 499) {
            var code = data.error.code;
            if (code === undefined) showError('Page is outdated. Please reload the page');else if (code === INVALID_EMAIL_OR_PASSWORD) showError('Wrong email or password');else if (code === BLOCKED_ACCOUNT) showError('Account is blocked');else if (code === 0 && data.error.status === 418) showError('Wrong email');
          } else if (status >= 500) {
            showError('Server is temporary unavailable');
          }
        });
      }
    });
  }

  var validationObject = {
    errorElement: 'div',
    errorClass: 'input-validation-message',
    rules: {
      password: {
        maxlength: 20,
        minlength: 5,
        required: true
      },
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      password: {
        required: $.i18n._("This field is required"),
        maxlength: $.i18n._("Length must be 5 to 20 symbols"),
        minlength: $.i18n._("Length must be 5 to 20 symbols")
      },
      email: {
        email: $.i18n._("Please enter a valid email address"),
        required: $.i18n._("This field is required")
      }
    },
    highlight: function highlight(element) {
      $(element).removeClass(this.errorClass).addClass('invalid-input');
    },
    unhighlight: function unhighlight(element) {
      var errorContainer = $(element).parent().find('.input-validation-message');
      errorContainer.removeClass('error');
      $(element).removeClass('invalid-input');
    },
    errorPlacement: function errorPlacement(error, element) {
      $(element).parent().find('.input-error').append(error);
    },
    submitHandler: function submitHandler(form) {
      if (form.dataset.form === 'popup-login') {
        loginViaRest(form);
      } else if (typeof registerHandler === 'function') {
        registerHandler(form);
      } else form.submit();
    }
  };
  $('.popup-login form').each(function () {
    $(this).validate(validationObject);
  });
  signupForm.on('submit', function (e) {
    if (!$(this).valid()) return false;
    signupForm.find('[type="submit"]').attr('disabled', true);
  });
  signupAgreement.focus(function (e) {
    signupAgreementBox.removeClass('input-invalid');
  });
  signupPassword.on('change', function (e) {
    $('[data-js="password-repeat"]').val(e.target.value);
  });
  $('.password-field').each(function () {
    var field = $(this).find('[name="password"]');
    var lock = $(this).find('.password-field__lock');
    lock.click(function () {
      if (field.attr('type') === 'password') field.attr('type', 'text');else field.attr('type', 'password');
    });
  });
} // Authorization by social


function handleSocialAuth(socTypeForm) {
  var openedWindow = null;
  var onError = null;

  function getDomain() {
    var href = document.location.href;
    if (/test\./.test(href)) return 'https://test.studybay.app';
    if (/dev/.test(href)) return 'https://' + document.location.host.split('.')[0] + '.studybay.local';
    return 'https://studybay.app';
  }

  function parseMessage(event) {
    if (event.data.type !== 'socialAuth') return;
    var status = event.data.payload.status;
    var redirectUrl = event.data.payload.redirect;

    if (status !== undefined) {
      if (openedWindow && openedWindow.close) openedWindow.close();

      switch (status) {
        case 0:
          {
            if (redirectUrl !== undefined) {
              window.location.assign(redirectUrl);
            } else {
              window.location.assign(getDomain() + '/home/');
            }

            break;
          }

        case 1:
          {
            if (typeof onError === 'function') {
              onError();
            }

            break;
          }

        default:
          break;
      }

      window.removeEventListener('message', parseMessage);
      onError = null;
    }
  }

  function authBySocNetwork(name) {
    var openerContext = window.open();
    var socRegId = name === 'facebook' ? '1' : '2';
    var currentUrl = getDomain();
    var logParams = "/?type_form=".concat(socTypeForm || 'sbLandingSocAuth', "_").concat(socRegId, "&reg_url=").concat(currentUrl).concat(searchParams.replace('?', '&'));
    fetch('/auth/getproviderurl/' + name + logParams + '/', {
      method: 'GET'
    }).then(function (r) {
      return r.json();
    }).then(function (data) {
      window.addEventListener('message', parseMessage);
      openedWindow = openerContext;
      openerContext.location = data.message;
    });
    return new Promise(function (resolve, reject) {
      onError = reject;
    });
  }

  $('.popup-login__btn-social').each(function () {
    var socialNetwork = $(this).data('social');
    $(this).click(function () {
      authBySocNetwork(socialNetwork).catch(function (error) {
        console.log(error);
      });
    });
  });
}

module.exports = function (socTypeForm, registerHandler) {
  $(function () {
    handleAuthForm(registerHandler);
    handleSocialAuth(socTypeForm);
  });
};

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClickOutside = exports.watchMedia = exports.viewportLarge = exports.viewportMedium = exports.viewportSmall = exports.preventScroll = exports.debounce = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var debounce = function debounce(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  // this is double debounce
  // it fires like this
  // calls:          1111111111111111
  // actually fired: 1000000000000001
  // so only first and last call
  var shouldCallMore;
  var timer;
  var maxWaitTimer;
  var isWaiting;
  var fnArgs = [];

  var stopWaiting = function stopWaiting() {
    if (shouldCallMore) fn.apply(void 0, _toConsumableArray(fnArgs));
    isWaiting = shouldCallMore = false;
  };

  var call = function call() {
    shouldCallMore = false;
    fn.apply(void 0, _toConsumableArray(fnArgs));
  };

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    fnArgs = args;
    shouldCallMore = true;
    clearTimeout(timer);
    timer = setTimeout(stopWaiting, wait);
    if (isWaiting) return;
    isWaiting = true;
    clearTimeout(maxWaitTimer);
    maxWaitTimer = setTimeout(call, 20);
  };
};

exports.debounce = debounce;

var preventScroll = function preventScroll() {
  var initialPosition = document.documentElement.style.position;
  var initialTop = document.documentElement.style.top;
  var initialScrollY = window.scrollY;
  document.documentElement.style.top = "-".concat(initialScrollY, "px");
  document.documentElement.style.position = 'fixed';
  return function () {
    document.documentElement.style.position = initialPosition;
    document.documentElement.style.top = initialTop;
    window.scrollTo(0, initialScrollY);
  };
};

exports.preventScroll = preventScroll;
var viewportSmall = "(max-width: 50rem)";
exports.viewportSmall = viewportSmall;
var viewportMedium = "(max-width: 80rem) and (min-width: ".concat(50 * parseFloat(getComputedStyle(document.documentElement).fontSize) + 1, "px)");
exports.viewportMedium = viewportMedium;
var viewportLarge = "(min-width: ".concat(80 * parseFloat(getComputedStyle(document.documentElement).fontSize) + 1, "px)");
exports.viewportLarge = viewportLarge;

var watchMedia = function watchMedia(mqs, cb) {
  var mq = window.matchMedia(mqs);

  var wrapperCb = function wrapperCb(e) {
    if (!e.matches) return;
    cb();
  };

  if (mq.addEventListener) mq.addEventListener('change', wrapperCb);else if (mq.addListener) mq.addListener(wrapperCb);
  if (mq.matches) cb();
  return function () {
    if (mq.removeEventListener) mq.removeEventListener('change', wrapperCb);else if (mq.removeListener) mq.removeListener(wrapperCb);
  };
}; // is click outside the element


exports.watchMedia = watchMedia;

var isClickOutside = function isClickOutside(windowClickEvent, element) {
  if (!windowClickEvent || !element) return;
  var cursorX = windowClickEvent.clientX;
  var cursorY = windowClickEvent.clientY; // this probably happened because clicked with spacebar

  if (cursorX === 0 && cursorY === 0) return false;
  var rect = element.getBoundingClientRect();
  var clickedOutsideX = cursorX < rect.left || cursorX > rect.right;
  var clickedOutsideY = cursorY < rect.top || cursorY > rect.bottom;
  return clickedOutsideX || clickedOutsideY;
};

exports.isClickOutside = isClickOutside;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _helpers = require("./helpers");

var _default = function _default() {
  var header = document.getElementById('page-header');
  var headerContainer = header.children[0];
  var headerBurgerOpen = document.getElementById('open-menu');
  var headerBurgerClose = document.getElementById('close-menu');
  var headerDropdownToggle = document.getElementById('header-dropdown-toggle');
  var headerDropdownDecoy = document.getElementById('header-dropdown-decoy');
  var headerDropdownContent = document.querySelector('#header-dropdown-toggle ~ [aria-labelledby="header-dropdown-toggle"]');
  var focustrapFirstMedium = document.querySelector('[data-focustrap-first*="m"]');
  var focustrapLastMedium = document.querySelector('[data-focustrap-last*="m"]');
  var focustrapFirstSmall = document.querySelector('[data-focustrap-first*="s"]');
  var focustrapLastSmall = document.querySelector('[data-focustrap-last*="s"]');
  var focustrapFirst = null;
  var focustrapLast = null;
  var elementToFocusOnMenuOpening = null;
  var restoreScroll = null; //check header--invert

  var isHeaderInvert = header.classList.contains('header--invert'); // turns dropdown into just regular content

  var destructurizeDropdown = function destructurizeDropdown() {
    return headerDropdownContent.removeAttribute('aria-expanded');
  }; // burger menu logic


  var openMenu = function openMenu() {
    header.setAttribute('aria-expanded', true);
    if (elementToFocusOnMenuOpening) elementToFocusOnMenuOpening.focus();
    restoreScroll = (0, _helpers.preventScroll)();
  };

  var closeMenu = function closeMenu() {
    header.setAttribute('aria-expanded', false);
    headerBurgerOpen.focus();
    if (restoreScroll) restoreScroll();
  };

  var openDropdown = function openDropdown() {
    headerDropdownContent.setAttribute('aria-expanded', true);
    headerDropdownToggle.classList.add('expanded');

    if (isHeaderInvert) {
      headerDropdownDecoy.classList.add('dropdown__decoy-expanded');
      headerContainer.classList.add('header__container-expanded');
    }

    window.addEventListener('click', hideDropdownOnOutsideClick);
  };

  var closeDropdown = function closeDropdown() {
    headerDropdownContent.setAttribute('aria-expanded', false);
    headerDropdownToggle.classList.remove('expanded');

    if (isHeaderInvert) {
      headerDropdownDecoy.classList.remove('dropdown__decoy-expanded');
      headerContainer.classList.remove('header__container-expanded');
    }

    window.removeEventListener('click', hideDropdownOnOutsideClick);
  };

  var toggleDropdown = function toggleDropdown() {
    var currentState = headerDropdownContent.getAttribute('aria-expanded') === 'true';
    var nextState = !currentState;
    if (nextState === true) openDropdown();else closeDropdown();
  };

  var hideDropdownOnOutsideClick = function hideDropdownOnOutsideClick(e) {
    var clickedToggler = !(0, _helpers.isClickOutside)(e, headerDropdownToggle);
    if (clickedToggler) return;
    var clickedOutsideDropdown = (0, _helpers.isClickOutside)(e, headerDropdownContent);
    var currentState = headerDropdownContent.getAttribute('aria-expanded') === 'true';
    if (clickedOutsideDropdown && currentState === true) closeDropdown();
  }; // fires when header sticks to top


  var manageStickyHeader = (0, _helpers.debounce)(function (e) {
    var becameSticky = e.target.documentElement.scrollTop > 0 || document.documentElement.style.position === 'fixed';
    header.classList.toggle('header--sticky', becameSticky);
  }, 100); // needed for correct tab order in burger menu

  var recalculateTabindicies = function recalculateTabindicies(size) {
    var elementsToInspect = Array.from(document.querySelectorAll('[data-tabindex]'));
    var model = elementsToInspect.map(function (elem) {
      var result = {
        elem: elem
      };
      var tabIndiciesTuple = elem.dataset.tabindex.split(' ');
      if (tabIndiciesTuple[0] !== '0') result.tabIndexLarge = tabIndiciesTuple[0];
      if (tabIndiciesTuple[1] !== '0') result.tabIndexMedium = tabIndiciesTuple[1];
      if (tabIndiciesTuple[2] !== '0') result.tabIndexSmall = tabIndiciesTuple[2];
      return result;
    });
    model.forEach(function (desc) {
      var elem = desc.elem;
      elem.removeAttribute('tabindex');

      if (size === 'large' && desc.tabIndexLarge) {
        elem.setAttribute('tabindex', desc.tabIndexLarge);
        if (desc.tabIndexLarge === '1') elementToFocusOnMenuOpening = elem;
      } else if (size === 'medium' && desc.tabIndexMedium) {
        elem.setAttribute('tabindex', desc.tabIndexMedium);
        if (desc.tabIndexMedium === '1') elementToFocusOnMenuOpening = elem;
      } else if (size === 'small' && desc.tabIndexSmall) {
        elem.setAttribute('tabindex', desc.tabIndexSmall);
        if (desc.tabIndexSmall === '1') elementToFocusOnMenuOpening = elem;
      }
    });
  };

  var getIsBurgerMenuOpened = function getIsBurgerMenuOpened() {
    return header.getAttribute('aria-expanded') === 'true';
  };

  var manageKeyDown = function manageKeyDown(e) {
    var isTab = e.code === 'Tab' && !e.shiftKey;
    var isShiftTab = e.code === 'Tab' && e.shiftKey;
    var isEsc = e.code === 'Escape';
    var shouldPrevent = isTab || isShiftTab || isEsc;
    var isBurgerMenuOpened = getIsBurgerMenuOpened();
    if (!isBurgerMenuOpened) return;
    var isFirstElementInFocus = document.activeElement === focustrapFirst;
    var isLastElementInFocus = document.activeElement === focustrapLast;
    if (isEsc) closeMenu();else if (isTab && isLastElementInFocus) focustrapFirst.focus();else if (isShiftTab && isFirstElementInFocus) focustrapLast.focus();
    if (isEsc || isTab && isLastElementInFocus || isShiftTab && isFirstElementInFocus) e.preventDefault();
  };

  if (headerDropdownToggle && headerDropdownContent) {
    headerDropdownToggle.addEventListener('click', toggleDropdown);
  }

  if (headerBurgerOpen && headerBurgerClose) {
    headerBurgerOpen.addEventListener('click', openMenu);
    headerBurgerClose.addEventListener('click', closeMenu);
  } // recalculate things on viewport width change


  var unwatchMQLarge = (0, _helpers.watchMedia)(_helpers.viewportLarge, function () {
    recalculateTabindicies('large');
    closeDropdown();
    closeMenu();
  });
  var unwatchMQMedium = (0, _helpers.watchMedia)(_helpers.viewportMedium, function () {
    destructurizeDropdown();
    recalculateTabindicies('medium');
    focustrapFirst = focustrapFirstMedium;
    focustrapLast = focustrapLastMedium;
  });
  var unwatchMQSmall = (0, _helpers.watchMedia)(_helpers.viewportSmall, function () {
    destructurizeDropdown();
    recalculateTabindicies('small');
    focustrapFirst = focustrapFirstSmall;
    focustrapLast = focustrapLastSmall;
  });
  window.addEventListener('scroll', manageStickyHeader);
  window.addEventListener('keydown', manageKeyDown);
  return function () {
    if (headerDropdownToggle) {
      headerDropdownToggle.removeEventListener('click', toggleDropdown);
    }

    if (headerBurgerOpen && headerBurgerClose) {
      headerBurgerOpen.removeEventListener('click', openMenu);
      headerBurgerClose.removeEventListener('click', closeMenu);
    }

    window.removeEventListener('scroll', manageStickyHeader);
    unwatchMQLarge();
    unwatchMQMedium();
    unwatchMQSmall();
  };
};

exports.default = _default;

},{"./helpers":3}],5:[function(require,module,exports){
"use strict";

var _index = _interopRequireDefault(require("../_modules/header/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('jquery-nice-select');

var authHandler = require('../_modules/authPopups/index');

var rid = new URLSearchParams(window.location.search).get('rid');
var sbus1112 = rid === 'f2efc6aa6d93147d';

function decorateUrlWithGAtracker(urlString) {
  var ga = window[window['GoogleAnalyticsObject']];
  var tracker;

  try {
    tracker = ga.getAll()[0];
    urlString = new window.gaplugins.Linker(tracker).decorate(urlString);
  } catch (error) {
    console.error('GA Error', error);
    return urlString;
  }

  return urlString;
}

function modifySignupFormActions() {
  var searchParams = window.location.search;
  var shortRegForms = $('#sendUnregordershortform,#sendUnregordershortform-1,#sendUnregordershortform-2,#sendUnregordershortform-3');
  shortRegForms.each(function () {
    var form = $(this);
    var action = form.attr('action');
    var queryIncluded = action.includes('/?');
    action += "".concat(queryIncluded ? searchParams.replace('?', '&') : searchParams);
    form.attr('action', action);
  });
  var logo = $('#header-main-logo');
  var logoHref = logo.prop('href');
  logo.attr('href', "".concat(logoHref).concat(searchParams));
}

function handleSignUpForms() {
  var shortRegForms = $('#sendUnregordershortform,#sendUnregordershortform-1,#sendUnregordershortform-2,#sendUnregordershortform-3');
  shortRegForms.on('submit', function (e) {
    var actionUrl = $(this).attr('action');
    var newActionUrl = decorateUrlWithGAtracker(actionUrl);
    $(this).attr('action', newActionUrl);
    if (!$(this).valid()) return false;
    disableSubmitButtons();
  });

  function disableSubmitButtons() {
    shortRegForms.each(function () {
      $(this).find('[type="submit"]').attr('disabled', true);
    });
  }
}

$(document).ready(function () {
  $.modal.defaults.closeText = '';
  $.modal.defaults.closeExisting = false;
  $('select').niceSelect();
  var mediaQuery = window.matchMedia('(max-width: 768px)');
  setResponsiveDesign(mediaQuery);
  mediaQuery.addListener(function (mqe) {
    setResponsiveDesign(mqe);
  });
  $('.icon-cards').slick({
    slidesToShow: 3,
    arrows: false,
    responsive: [{
      breakpoint: 8000,
      settings: "unslick"
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }]
  });
  $('.reviews').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }]
  });
  $('.scroll-to-title').on('click', function (e) {
    e.preventDefault();
    $.scrollTo('.header', 500);
  });

  if (document.querySelector('#receive_notifications_header')) {
    document.querySelector('#receive_notifications_header').addEventListener('change', function (e) {
      document.querySelector('#sendUnregordershortform-1 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
      document.querySelector('#sendUnregordershortform-2 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
    });
  }

  if (document.querySelector('#receive_notifications_l-form')) {
    document.querySelector('#receive_notifications_l-form').addEventListener('change', function (e) {
      document.querySelector('#sendUnregordershortform-3 input[name="receive_notifications"]').value = e.target.checked ? 1 : 0;
    });
  }

  function setResponsiveDesign(mqe) {
    resetSlicks();
    if (mqe.matches) useMobileDesign();else useDesktopDesign();
  }

  function useDesktopDesign() {
    $('.you-item__carousel').slick({
      slidesToShow: 1,
      arrows: true,
      dots: false,
      fade: true,
      swipe: false,
      prevArrow: $('.you__nav-arrows--prev'),
      nextArrow: $('.you__nav-arrows--next'),
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500
    });
    $('.you-item__reviews').each(function (key, item) {
      $(this).slick({
        slidesToShow: 1,
        arrows: window.innerWidth > 768,
        responsive: [{
          breakpoint: 8000,
          settings: "unslick"
        }]
      });
    });
    $('.links-list__inner-item').each(function (ind, el) {
      $(this).find('.links-tooltip').removeAttr('id');
      $(this).find('.links-list__inner-item-link').removeAttr('href').removeAttr('rel');
    });
  }

  function useMobileDesign() {
    $('.you-item__carousel--mobile').slick({
      slidesToShow: 1,
      arrows: false,
      dots: true,
      fade: true,
      swipe: true,
      // adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500
    });
    $('.links-list').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    }); // Responsive links

    $('.links-list__inner-item').each(function (ind, el) {
      var id = 'items-link-' + ind;
      $(this).find('.links-tooltip').attr('id', id);
      $(this).find('.links-list__inner-item-link').attr('href', '#' + id).attr('rel', 'modal:open');
      $(this).find('.links-tooltip__list-item-link').attr('rel', 'modal:close');
    });
  }

  function resetSlicks() {
    $('.l-links, .l-you').find('.slick-initialized').slick('unslick');
  }

  $('.popular-service').slick({
    slidesToShow: 1,
    arrows: false,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000
  }); // For step form can't use jquery validation since we can't get back on steps !!!

  var stepFormError = $('.step-form-error');

  function setStepFormError(message) {
    stepFormError.text(message).show();
  }

  function resetStepFormError() {
    stepFormError.hide();
  }

  $('.form-step--1 > .form-step__btn').click(function () {
    $(this).parent().removeClass('form-step--active');
    $('.form-step--2').addClass('form-step--active');
  });
  $('.form-step--2 > .form-step__btn').click(function () {
    var title = $('.form-step--2 .input-text').val();
    if (!title.length) return setStepFormError('This field is required.');
    resetStepFormError();
    $(this).parent().removeClass('form-step--active');
    $('.form-step--3').addClass('form-step--active');
  });
  $('.form-step--3 > .form-step__btn').click(function (e) {
    e.preventDefault();
    var email = $('.form-step--3 .input-text').val();
    if (!email.length) return setStepFormError('This field is required.');
    if (!/\S+@\S+\.\S+/.test(email)) return setStepFormError('Please enter a valid email address.');
    resetStepFormError();
    $('.form-steps').submit();
  });
  modifySignupFormActions();
  authHandler('sb_contentWritingSocAuth');
  handleSignUpForms();
  (0, _index.default)();
}); // Promocode

$(function () {
  // Promocode
  $('.header__have-promo-link').click(function () {
    $(this).hide();
    $('.header__have-promo-field').addClass('header__have-promo-field--active');
  });
  var promocodeInput = $('#promocode-input');
  var checkPromocodeBtn = $('.header__have-promo-field-btn');
  var wrongPromocode = $('.header__have-promo-field-no');
  var wrongPromocodeText = wrongPromocode.find('.header__have-promo-field-no__text');
  promocodeInput.focus(function () {
    checkPromocodeBtn.show();
    wrongPromocode.hide();
  });
  wrongPromocode.on('click', function () {
    wrongPromocode.hide();
    checkPromocodeBtn.show();
  });
  checkPromocodeBtn.click(function () {
    var promocode = promocodeInput.val();

    if (promocode < 1) {
      checkPromocodeBtn.hide();
      wrongPromocodeText.html($.i18n._('Invalid promo code'));
      wrongPromocode.css('display', 'flex');
    } else {
      $.post('/ajax/checkPromocodeAll', {
        code: promocode
      }).done(function (data) {
        var status = data.status;

        if (status === 1) {
          $('.header__have-promo-field-yes').val('Success! You get ' + data.sum).css('display', 'flex');
          checkPromocodeBtn.hide();
          promocodeInput.attr('disabled', 'disabled');
          $('[data-js="promocode"]').each(function (ind, el) {
            el.value = promocode;
          });
          $('[data-js="promocodeSum"]').text(data.sum);
        }

        if (status === -1 || status === -2) {
          wrongPromocodeText.html($.i18n._('Invalid promo code'));
          wrongPromocode.css('display', 'flex');
          checkPromocodeBtn.hide();
        }

        if (status === -3) {
          wrongPromocodeText.html($.i18n._('Required field'));
          wrongPromocode.css('display', 'flex');
          checkPromocodeBtn.hide();
        }
      });
    }
  });
}); // Handle mobile menu

$(function () {
  var burgerBtn = $('#burger-menu-btn');
  var backdrop = $('#menu-backdrop');
  var mobileMenu = $('#mobile-menu');
  burgerBtn.on('click', function (e) {
    mobileMenu.toggleClass('active');
  });
  backdrop.on('click', function () {
    mobileMenu.removeClass('active');
  });
}); // Validate forms

$(function () {
  $('.form--modern-1').each(function () {
    $(this).validate({
      errorElement: 'div',
      errorClass: 'input-validation-message',
      rules: {
        title: {
          required: true
        },
        type_id: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      },
      messages: {
        title: $.i18n._("This field is required."),
        type_id: $.i18n._("This field is required."),
        email: {
          email: $.i18n._("Please enter a valid email address."),
          required: $.i18n._("This field is required.")
        }
      },
      highlight: function highlight(element) {
        $(element).removeClass(this.errorClass).addClass('invalid-input');
      },
      unhighlight: function unhighlight(element) {
        var errorContainer = $(element).parent().find('.input-validation-message');
        errorContainer.removeClass('error');
        $(element).removeClass('invalid-input');
      },
      errorPlacement: function errorPlacement(error, element) {
        $(element).parent().find('.input-error').append(error);
      }
    });
  });
});

},{"../_modules/authPopups/index":2,"../_modules/header/index.js":4,"jquery-nice-select":1}]},{},[5]);
